export default __webpack_public_path__ + "static/media/error-bound.9d27ae2a.svg";